import React from 'react';

import { ReadOnlyLockEndBadge } from './locked-icon-badge';

export const readOnlyButtonEndIcon = (
  readOnly: boolean,
): React.ReactElement | undefined =>
  (readOnly ? <ReadOnlyLockEndBadge /> : undefined);
